import React, { FC } from 'react'
import { NumberFormatValues, PatternFormat } from 'react-number-format'
import { BtInputBase, BtInputBaseProps } from './BtInputBase'

export type BtDateInputFormat = 'YYYY' | 'MM/YYYY' | 'MM/DD/YYYY'

export interface BtDateInputProps extends BtInputBaseProps {
  format: BtDateInputFormat
}

export const BtDateInput: FC<BtDateInputProps> = ({
  size = 'large',
  value,
  label,
  format,
  required,
  disabled,
  placeholder,
  validate,
  onChangeText,
  testID,
  style,
}) => {
  const handleValueChange = (formatValues: NumberFormatValues) => {
    if (onChangeText) {
      onChangeText(formatValues.formattedValue)
    }
  }

  const patternFormat = format.replace(/([A-Z])/g, '#')

  return (
    <PatternFormat
      format={patternFormat}
      placeholder={placeholder || format}
      size={size}
      label={label}
      value={value}
      required={required}
      disabled={disabled}
      keyboardType="number-pad"
      customInput={BtInputBase}
      validate={validate}
      allowEmptyFormatting={false}
      onValueChange={handleValueChange}
      testID={testID}
      style={style}
    />
  )
}
